import { Props as RadioProps } from '@storeblocks/radio';
import { RadioButtonsProps } from '@storeblocks/radio-buttons';

export const getRebrandedRadioDirection = (
  direction: RadioProps['direction']
): RadioButtonsProps['direction'] => {
  if (direction === 'horizontal') {
    return 'row';
  }
  return 'column';
};

export const getRebrandedRadioOptions = (
  options: RadioProps['options'],
  currentValue: RadioProps['value']
): RadioButtonsProps['options'] => {
  return options.map(({ label, id, value, disabled, hint }) => {
    return {
      label,
      id,
      value,
      disabled,
      hint,
      defaultChecked: value === currentValue
    };
  });
};

export const getRebrandedRadioOnChange =
  (onChange: RadioProps['onChange']): RadioButtonsProps['onChange'] =>
  (event: React.ChangeEvent<HTMLInputElement>) => {
    const selected = {
      value: event.target.value,
      label: event.target.name,
      id: event.target.id
    };
    onChange(event, selected);
  };

export const getRebrandedRadioLegendProps = (
  label: RadioProps['label'],
  hint: RadioProps['hint']
): RadioButtonsProps['legendProps'] => {
  return {
    title: (label as string) || '',
    hint
  };
};
